export const gptFormattedKeys = {
  ec2: 'EC2',
  rds: 'RDS',
  s3: 'S3',
  aws: 'AWS',
  gcp: 'GCP',
  sp: 'SP',
  ri: 'RI',
};
